module.exports = __webpack_public_path__ + "static/img/logo.6a920898.png";